import { render } from "./Testimonial3Content.vue?vue&type=template&id=fd3da024&scoped=true&ts=true"
import script from "./Testimonial3Content.vue?vue&type=script&lang=ts"
export * from "./Testimonial3Content.vue?vue&type=script&lang=ts"

import "./Testimonial3Content.vue?vue&type=style&index=0&id=fd3da024&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3da024"]])

export default __exports__